import { TOrderStatus } from "sierra";

export function getOrderStatus({ assigned_to, order_status, is_cancelled, order_paid }: { assigned_to: number | null, order_status: TOrderStatus, is_cancelled: boolean, order_paid: boolean }) {
    return is_cancelled ? 'Cancelled' :
        !order_paid ? 'Awaiting Payment' :
            !assigned_to ? 'Awaiting Assignment' :
                order_status === 'validating' ? 'Awaiting Validation'
                    : order_status === 'pending' ? 'Awaiting Correction'
                        : order_status === 'completed' ? 'Order Completed'
                            : order_status === 'awaiting' ? 'Awaiting External Approval'
                                : 'Unknown'
}